import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { HowItWorksPage } from './pages/HowItWorksPage';
import { ContactPage } from './pages/ContactPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { BlogPage } from './pages/BlogPage';
import { BlogPostPage } from './pages/BlogPostPage';
import { ServiceDetailPage } from './pages/ServiceDetailPage';
import { LocationDetailPage } from './pages/LocationDetailPage';
export function App() {
  return <BrowserRouter data-id="element-0">
      <div className="flex flex-col min-h-screen" data-id="element-1">
        <Header data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<HomePage data-id="element-5" />} data-id="element-4" />
          <Route path="/services" element={<ServicesPage data-id="element-7" />} data-id="element-6" />
          <Route path="/services/:serviceSlug" element={<ServiceDetailPage data-id="element-9" />} data-id="element-8" />
          <Route path="/how-it-works" element={<HowItWorksPage data-id="element-11" />} data-id="element-10" />
          <Route path="/locations/:locationSlug" element={<LocationDetailPage data-id="element-13" />} data-id="element-12" />
          <Route path="/contact" element={<ContactPage data-id="element-15" />} data-id="element-14" />
          <Route path="/terms" element={<TermsPage data-id="element-17" />} data-id="element-16" />
          <Route path="/privacy" element={<PrivacyPage data-id="element-19" />} data-id="element-18" />
          <Route path="/blog" element={<BlogPage data-id="element-21" />} data-id="element-20" />
          <Route path="/blog/:slug" element={<BlogPostPage data-id="element-23" />} data-id="element-22" />
        </Routes>
        <Footer data-id="element-24" />
      </div>
    </BrowserRouter>;
}